function ErrorMessage(props) {
  return props.message ? <div>{props.message}</div> : <></>;
}

export default ErrorMessage;